import React, { useState } from 'react'
import PropTypes from 'prop-types'

const Thumbnail = ({ url, fallbackUrl, imageComponent: ImageComponent }) => {
    const [src, setSrc] = useState(url || fallbackUrl)

    const onError = (event) => {
        if (event.currentTarget.src !== fallbackUrl) {
            setSrc(fallbackUrl)
        }
    }

    return (
        <ImageComponent src={src} onError={onError} />
    )
}

Thumbnail.propTypes = {
    url: PropTypes.string,
    fallbackUrl: PropTypes.string,
    imageComponent: PropTypes.elementType,
}

Thumbnail.defaultProps = {
    imageComponent: (props) => <img {...props} />,
}

export default Thumbnail
